import type { TLocalizedField } from '@/domains/investor/types/investor.types'
import type { LOCALE_CODE } from '~/types/contentful'

export const PRIMARY_LOCALE: LOCALE_CODE = 'pl-PL'
export const FALLBACK_LOCALE: LOCALE_CODE = 'en-US'
export const LOCALE_FALLBACK_ORDER: LOCALE_CODE[] = [PRIMARY_LOCALE, FALLBACK_LOCALE]

export function getPreferredLocale(localeValue?: string): LOCALE_CODE {
  return localeValue?.toLowerCase().startsWith('pl') ? PRIMARY_LOCALE : FALLBACK_LOCALE
}

export function getLocalizedValue(value: unknown, activeLocale: LOCALE_CODE): unknown {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return value
  }

  const localizedValue = value as TLocalizedField<unknown>
  const hasLocaleKey = activeLocale in localizedValue || PRIMARY_LOCALE in localizedValue || FALLBACK_LOCALE in localizedValue

  if (!hasLocaleKey) {
    return value
  }

  return localizedValue[activeLocale]
    ?? localizedValue[PRIMARY_LOCALE]
    ?? localizedValue[FALLBACK_LOCALE]
    ?? Object.values(localizedValue).find(item => item !== undefined)
}
